import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function FileexportReducer(state = initialState.fileexport, action: any) {
  switch (action.type) {
    case types.SAVE_FILEEXPORT_SUCCESS:
      return action.fileexport;
    default:
      return state;
  }
}
